/**
 * アナウンスバー: ブロックごとに閲覧者の国（Shopify 検出）で表示を切り替える
 *
 * 【前提（Liquid / CSS と役割分担）】
 * - 表示期間（開始・終了日時）: Liquid でブロックごとに絞り込み済み（本 JS の対象外）
 * - 販売対象国コード一覧: .utility-bar の data-selling-country-codes（マーケット有効国）
 * - 各ブロック: data-announcement-country-mode（all / target_countries_only / non_target_countries_only）
 * - 「all」以外は CSS で初期 display:none → 本 JS が表示対象に .is-country-gated--show を付与して表示
 * - フロントのみ: 非表示確定のブロックは DOM から remove（テーマエディタでは DOM に残す）
 * - 国別ありスライダーは .announcement-bar-slider--arrows-await-country で矢印初期非表示 → 実表示2枚以上で .announcement-bar-slider--arrows-visible
 * - テーマエディタ: data-shopify-design-mode="true" のとき本スクリプトは何もしない（CSS も編集時は全表示）
 * - CMP とは無関係
 */
(function () {
  // ---------------------------------------------------------------------------
  // 定数（announcement-bar.liquid の data 属性・クラス名と一致させる）
  // ---------------------------------------------------------------------------
  var ATTR_ROOT = 'data-announcement-country-bar';
  var ATTR_MODE = 'data-announcement-country-mode';
  var ATTR_DESIGN = 'data-shopify-design-mode';
  /** 国判定の結果「このブロックを表示する」ときに付与（CSS の display:revert とセット） */
  var CLASS_SHOW = 'is-country-gated--show';
  /** 実表示スライドが2枚以上のとき矢印を出す（--arrows-await-country 時のみ有効） */
  var CLASS_ARROWS_VISIBLE = 'announcement-bar-slider--arrows-visible';

  // ---------------------------------------------------------------------------
  // テスト用: URL ?test_country=XX で検出国を上書き（オーバーレイ等と同様）
  // ---------------------------------------------------------------------------
  function getTestCountryFromUrl() {
    var m = window.location && window.location.search
      ? window.location.search.match(/[?&]test_country=([A-Za-z]{2})/)
      : null;
    return m ? m[1].toUpperCase() : null;
  }

  // ---------------------------------------------------------------------------
  // data-selling-country-codes（カンマ区切り）→ 大文字の配列
  // ---------------------------------------------------------------------------
  function parseSellingCodes(str) {
    if (!str || !String(str).trim()) return [];
    return String(str)
      .split(',')
      .map(function (s) {
        return s.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  // ---------------------------------------------------------------------------
  // Shopify が検出した閲覧者の国コード（browsing_context_suggestions.json）
  // ---------------------------------------------------------------------------
  function fetchDetectedCountry() {
    var root =
      typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    var url = root + 'browsing_context_suggestions.json?country[enabled]=true';
    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var h = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        return h ? String(h).toUpperCase() : null;
      })
      .catch(function () {
        return null;
      });
  }

  // ---------------------------------------------------------------------------
  // ブロック設定（mode）と国コード・販売対象国リストから「このブロックを表示するか」
  // - 国が取れないときは true（安全側: 非表示にしない）
  // ---------------------------------------------------------------------------
  function shouldShowBlock(mode, countryCode, sellingCodes) {
    if (!mode || mode === 'all') return true;
    if (!countryCode) return true;
    var inList =
      sellingCodes.length > 0 ? sellingCodes.indexOf(countryCode) !== -1 : false;
    if (mode === 'target_countries_only') return inList;
    if (mode === 'non_target_countries_only') return !inList;
    return true;
  }

  // ---------------------------------------------------------------------------
  // スライド表示枚数が変わったあと、テーマの slideshow-component が幅・ページを再計算
  // ---------------------------------------------------------------------------
  function refreshSlideshow(slideshow) {
    if (!slideshow || typeof slideshow.resetPages !== 'function') return;
    slideshow.resetPages();
    if (slideshow.slider) slideshow.slider.scrollLeft = 0;
  }

  // ---------------------------------------------------------------------------
  // 国別スライダー専用: 矢印の表示とオートプレイ
  // - Liquid で .announcement-bar-slider--arrows-await-country が付いているときだけ動作
  // - 実表示が2枚未満: 矢印非表示のまま + pause()
  // - 実表示が2枚以上: .announcement-bar-slider--arrows-visible + オートプレイONなら play()
  // ---------------------------------------------------------------------------
  function setAnnouncementSliderArrowsAndAutoplay(slideshow, visibleCount) {
    var wrap = slideshow.querySelector('.announcement-bar-slider');
    if (!wrap || !wrap.classList.contains('announcement-bar-slider--arrows-await-country')) return;

    if (visibleCount >= 2) {
      wrap.classList.add(CLASS_ARROWS_VISIBLE);
      if (
        slideshow.slider &&
        slideshow.slider.getAttribute('data-autoplay') === 'true' &&
        typeof slideshow.play === 'function'
      ) {
        slideshow.play();
      }
    } else {
      wrap.classList.remove(CLASS_ARROWS_VISIBLE);
      if (typeof slideshow.pause === 'function') slideshow.pause();
    }
  }

  // ---------------------------------------------------------------------------
  // スライド1枚が「画面上見えている」か（mode=all は常に表示扱い / それ以外は CLASS_SHOW 必須）
  // ---------------------------------------------------------------------------
  function isSlideVisible(slide) {
    var mode = slide.getAttribute(ATTR_MODE) || 'all';
    if (mode === 'all') return true;
    return slide.classList.contains(CLASS_SHOW);
  }

  // ---------------------------------------------------------------------------
  // 1 セクション分（.utility-bar[data-announcement-country-bar]）の処理
  // ---------------------------------------------------------------------------
  function processBar(root) {
    // テーマカスタマイザーでは国別ロジックを走らせない
    if (root.getAttribute(ATTR_DESIGN) === 'true') return;

    var sellingCodesStr = root.getAttribute('data-selling-country-codes') || '';
    var sellingCodes = parseSellingCodes(sellingCodesStr);

    // ブロックごとのルート要素（単一時は .announcement-bar、複数時は各 .slideshow__slide）
    var targets = root.querySelectorAll('[' + ATTR_MODE + ']');

    // すべて「all」なら API も class 操作も不要（矢印も Liquid 側で通常表示）
    var needsFetch = false;
    targets.forEach(function (el) {
      var mode = el.getAttribute(ATTR_MODE) || 'all';
      if (mode !== 'all') needsFetch = true;
    });
    if (!needsFetch) return;

    fetchDetectedCountry().then(function (detected) {
      // テスト用 URL パラメータがあれば検出結果より優先
      var countryCode = getTestCountryFromUrl() || detected;

      // 触った slideshow-component を重複なく集める（複数スライドをまとめて後処理）
      var slideshowsToRefresh = [];

      function pushSlideshow(el) {
        var slideshow = el.closest('slideshow-component');
        if (slideshow && slideshowsToRefresh.indexOf(slideshow) === -1) {
          slideshowsToRefresh.push(slideshow);
        }
      }

      var targetList = Array.prototype.slice.call(
        root.querySelectorAll('[' + ATTR_MODE + ']')
      );
      var toRemove = [];

      targetList.forEach(function (el) {
        var mode = el.getAttribute(ATTR_MODE) || 'all';
        if (mode === 'all') return;

        if (shouldShowBlock(mode, countryCode, sellingCodes)) {
          el.classList.add(CLASS_SHOW);
          el.removeAttribute('aria-hidden');
          pushSlideshow(el);
        } else {
          toRemove.push(el);
          pushSlideshow(el);
        }
      });

      toRemove.forEach(function (el) {
        el.remove();
      });

      // data-announcement-country-mode を持つ要素が1つも無い＝アナウンス枠が空（本番のみ）
      if (!root.querySelector('[' + ATTR_MODE + ']')) {
        root.classList.add('utility-bar--country-announcement-empty');
      }

      slideshowsToRefresh.forEach(function (slideshow) {
        var slides = slideshow.querySelectorAll('.slideshow__slide');
        var visibleCount = 0;
        slides.forEach(function (slide) {
          if (isSlideVisible(slide)) visibleCount++;
        });

        if (visibleCount === 0) {
          slideshow.style.display = 'none';
          slideshow.setAttribute('aria-hidden', 'true');
          setAnnouncementSliderArrowsAndAutoplay(slideshow, 0);
        } else {
          slideshow.style.display = '';
          slideshow.removeAttribute('aria-hidden');
          // display:revert 反映後に resetPages するため 1 フレーム待つ
          requestAnimationFrame(function () {
            refreshSlideshow(slideshow);
            setAnnouncementSliderArrowsAndAutoplay(slideshow, visibleCount);
          });
        }
      });
    });
  }

  // ---------------------------------------------------------------------------
  // 起動: ヘッダー内の該当 .utility-bar ごとに processBar
  // ---------------------------------------------------------------------------
  function init() {
    document.querySelectorAll('[' + ATTR_ROOT + '="true"]').forEach(processBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
